import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, OnDestroy} from '@angular/core';
import { Subscription } from 'rxjs';

import { SettingsRulesEditorService } from '@app/services/settings/srules.service';
import { KeySelectItem } from '@core/models/select-item.model';

import * as fromRulesModel from '@app/models/rules';
// import { SettingsRulesEditScroll } from '@app/store/state/settings/rules/rules.state';

@Component({
  selector: 'settings-rules-rule-form-helper-select-multiple',
  templateUrl: './helper-select-multiple.component.html',
  styleUrls: ['./helper-select-multiple.component.scss'],
})
export class SettingsRulesFormHelperSelectMultipleComponent implements OnInit, OnChanges, OnDestroy {

    @Input() disabled: boolean;
    @Input() optionsSelected: Array<string | number> = [];
    @Input() label: string = "";
    @Input() options: fromRulesModel.AvailableRuleActionVariableValueItem[] = [];
    @Input() placeholder: string = "";
    @Input() key: string = '';
    // @Output() selectScrollTop = new EventEmitter<number>();
    @Output() select = new EventEmitter<fromRulesModel.AvailableRuleItem[]>();

    public items: Array<KeySelectItem> = [];
    public scrollTopValue: number = 0;

    private scrollSubscriptor: Subscription;

    constructor (public editorSrv: SettingsRulesEditorService){}

    ngOnInit() {
        this.init();
        // let formId = uniqid();
        // this.scrollSubscriptor = this.editorSrv.selectScroll().subscribe((scroll: Array<SettingsRulesEditScroll>) => {
        //     let selectScroll = scroll.filter((s: SettingsRulesEditScroll) => s.key == this.key);

        //     this.scrollTopValue = selectScroll.length > 0 ? selectScroll[0].value : 0;
        // })
    }

    ngOnDestroy(): void {
        // this.scrollSubscriptor.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges){
        if(changes.options) {
            this.init();
        }
    }

    protected init() {
        this.items = this.options.map((o: fromRulesModel.AvailableRuleActionVariableValueItem) => ({...o,
            selected: this.isSelected(o.key.toString()),
            key: o.key.toString(),
            disabled: o.options?.hasOwnProperty('selectable') ? !o.options.selectable : false
        }));
    }

    private isSelected(key: string) : boolean {
        return this.optionsSelected.map((o: string | number) => o.toString()).indexOf(key) > -1;
    }

    onSelect(select: Array<string | number>) {
        let selected = select.map((v: string | number) => v.toString());

        let oselected = this.options.filter((o: fromRulesModel.AvailableRuleItem)=> selected.indexOf(o.key.toString()) > -1);

        this.select.emit(oselected);
    }

    onScrollTop(value: number){
        this.editorSrv.setScroll(this.key, value);
    }
}
